


























































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VanillaModal from 'vanilla-modal';
import UserSettingValues from '@/store/user-setting-values';
import config from '@/config';
const UserSettings = namespace('UserSettings');


@Component
export default class Settings extends Vue {

    public modal?: VanillaModal;

    public colours: Array<string> = [
        'blue',
        'red',
        'white',
        'green',
        'yellow',
        'pink',
        'orange',
        'magenta',
        'lime',
        'aqua',
        'black',
        'grey',
        'purple',
    ];

    public get backgrounds(): { [id: string]: string } {
        return config.backgrounds;
    }

    public settingsData: UserSettingValues = {
        background: 'white',
        probeSizeMultiple: 10,
        bodySizeMultiple: 10,
        markerSizeMultiple: 10,
        asteroidSizeMultiple: 10,
        planetTrajectoryColor: 'blue',
        probeTrajectoryColor: 'white',
        asteroidTrajectoryColor: 'red',
        probeColor: 'white',
        markerColor: 'green',
        cameraTracksProbe: true,
    };

    @UserSettings.State
    public Data!: UserSettingValues;

    @UserSettings.Action
    public Update!: (userSettings: UserSettingValues) => Promise<void>;

    @UserSettings.Action
    public Load!: () => void;

    protected mounted() {
        window.console.log(`Settings mounted()`);
        this.Load();

        window.console.log(this.Data);
        this.settingsData = this.Data;
    }

    public show() {
        window.console.log(`show()`);
        this.modal = new VanillaModal();
        window.console.log(`this.modal.open('#settingsModal');`);
        this.modal.open('#settingsModal');
    }

    public async save() {
        await this.Update(this.settingsData);
        if (this.modal) {
            this.modal.close();
        }
    }
}

